export enum LoanStatus {
  Booked = 'Booked',
  Booking = 'Booking',
  Proposal = 'Proposal',
  Void = 'Void',
  New = 'New'
}
